/*
 * Copyright (c) 2017 Topcoder, Inc. All rights reserved.
 */

/*
 * App configurations
 */

/**
 * server url
 */

const BUILD_ENV = process.env.BUILD_ENV;
const API_HOST: any = {
  local: "http://localhost:3000",
  prod: "https://api.ognomy.com",
  dev: "https://api-dev.ognomy.com",
  tmp: "https://api-tmp.ognomy.com",
  staging: "https://api-tmp.ognomy.com",
  sandbox: "https://api-sandbox.ognomy.com",
};
export const SERVER_URL: string = API_HOST[BUILD_ENV || "local"];
export const FRESHPAINT_ENV_IDS: any = {
  "https://api.ognomy.com": "317a5bd9-03c2-47e7-a4c6-2507a6b6ba3c",
  "https://api-tmp.ognomy.com": "2b4de72f-0219-4951-8515-c124f13c93f1",
  "https://api-dev.ognomy.com": "fe48adbf-ce4c-4709-a7e8-585e41ee48d9",
  "http://localhost:3000": "2b4de72f-0219-4951-8515-c124f13c93f1",
};

const FE_HOST: any = {
  local: "http://localhost:3000",
  prod: "https://patient.ognomy.com",
  dev: "https://patient-dev.ognomy.com",
  tmp: "https://patient-tmp.ognomy.com",
};
export const FE_URL = FE_HOST[BUILD_ENV || "local"];

export const META = {
  PAGE_TITLE_SUFFIX: "Ognomy",
  PAGE_DESCRIPTION: "Ognomy",
  PAGE_KEYWORDS: "Ognomy",
};

export const DATE_FORMAT = "MM/DD/YYYY";
export const FORMAT_DATE_KEY = "YYYY-MM-DD"; // 2020-01-30
export const FORMAT_YEAR_MONTH = "YYYY-MM"; // 2020-01
export const FORMAT_MONTH = "MMM YYYY"; // Jun 2021
export const FORMAT_YEAR = "YYYY"; // 2021
export const CREDIT_FMT = "MM/YY";
export const FORMAT_MONTH_SHORT = "MMM"; // Jun
export const FORMAT_HOUR = "hh:mm"; // 10:00
export const FORMAT_HOUR_12 = "A"; // PM
export const FORMAT_HOUR_FULL = "hh:mm A"; // 10:00 PM
export const SEND_TIME_COUNT = 60000;

export const RegistrationDoneBannerVideoId = "qmN1Gf8rRc8";

export const PasswordRule = [
  "8 characters long",
  "An uppercase letter",
  "A lowercase letter",
  "A number",
  "A special character (e.g. !,#,@)",
];

export const stateDropdownOptions = [];
export const INSURANCE_RELATION = [
  "Parent",
  "Self",
  "Child",
  "Spouse",
  "Other",
];
/**
 * open meeting before x minutes
 * @type {number}
 */
export const OPEN_MEETING_BEFORE = 240;

export const OrderType = {
  HST: "HST",
  APAP: "APAP",
  OTHER_PAP: "Other PAP",
  OTHER: "Other",
};

export const APPOINTMENT_TITLE = "Consultation";

export const S_NEW_ZZZ_URI =
  "https://ognomy.com/wp-json/wp/v2/posts?per_page=3&categories=10,8,6,5,4,3,1&exclude=22,271,264";
export const TESTIMONIALS = [
  "This app has been very easy to use and I highly recommend it.",
  "Using this app to link my nightly sleep results/ changes to Dr. RIFKIN to monitor and adjust was the best decision I've made to improve my sleep.",
  "The sleep test was simple and within 2 weeks of my diagnosis I was able to get my CPAP machine. I am sleeping through the night for the first time in my life and no longer need to nap every day. LIFE CHANGING.",
  "The app is simple to use and provides a good way to communicate with the Dr. and track your progress.",
  "A convenient, secure way to meet with the physician. Highly recommend.",
  "My first virtual meeting with Dr. Rifkin was great - he is such a “down-to-earth” provider. The best part is not having to spend a night in a sleep study.",
  "Ognomy could not have been more convenient/efficient. The process from the diagnosis to treatment was so quick as well.",
  "Put off doing a sleep study because the thought of people watching me sleep gave me so much anxiety, but hearing from others who have been diagnosed with sleep apnea, their road to get there was NOT as simple as Ognomy makes it.",
  "I was able to do all my sleep studies at home in the comfort for my room and it went so smoothly. I recommend this app to everyone it’s amazing!",
  "App is very functional, well-designed, and the developer has been supporting it steadfastly I think. The future is right here in this app so download it already and stop reading reviews.",
  "Very convenient and user friendly! Would highly recommend this app to patients seeking a hassle-free experience with a sleep medicine specialist physician. And I’m a fan of Sheepa! :)",
  "The home home sleep study equipment was not only easy to use but very comfortable to wear while sleeping. They have really taken the hassle out of getting tested for sleep apnea!",
  "Definitely the way of the future. I was able to have my sleep study at home and quickly discuss test results and treatment options directly with the physician. Would definitely recommend.",
  "I was a little skeptical at first having never tried this approach before. But it has been an absolute pleasure to deal with these people! They care very much and respond quickly. Highly recommend!!",
  "Easy home sleep study. Great help with understanding what a sleep disorder is and how to correct it. Dr. Rifkin is absolutely the best. I’m evening loosing those packed bags under my eyes 😂😂",
  "Very easy to make and appointment with my doctor. The app is very fast and responsive.",
  "Such a compassionate doctor. It would be so beautiful if every doctor showed the same bedside manor as Dr. Akinnusi. So much reassurance! Thank you🌻",
];
